module.exports = __webpack_public_path__ + "img/plug-light.c5d6793f.svg";